import { useCallback, useState } from 'react'

const STORAGE_KEY = 'hop-sidebar-menu-expanded'

const readStored = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

const persist = (expanded: boolean) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(expanded))
  } catch {
    // Private browsing or full storage: the choice simply lasts for the session.
  }
}

const useSidebarMenuExpanded = () => {
  const [expanded, setExpanded] = useState(readStored)

  const toggle = useCallback(() => {
    const next = !expanded
    setExpanded(next)
    persist(next)
  }, [expanded])

  return { expanded, toggle }
}

export default useSidebarMenuExpanded
